export default "__VITE_ASSET__70c94ff5__"